import { useMutation, useQueryClient } from "@tanstack/react-query";
import { useApiClient } from "@playbookai/api-clients";
import { kpiApi } from "../api/live-client.js";
import type {
  ManagedKpiObservation,
  RecordKpiObservationInput,
} from "../api/types.js";
import { invalidateAfterObservationWrite } from "./kpiQueryKeys.js";

export interface RecordKpiObservationVars {
  readonly kpiId: string;
  readonly input: RecordKpiObservationInput;
}

/**
 * Append a reading to a KPI's ledger (`POST /v1/kpis/:id/observations`).
 *
 * Staleifies through the shared {@link invalidateAfterObservationWrite} — the
 * same detail/observations/lists sweep the batch write performs, stated once
 * so the two cannot drift.
 */
export function useRecordKpiObservation() {
  const config = useApiClient();
  const qc = useQueryClient();
  return useMutation<ManagedKpiObservation, Error, RecordKpiObservationVars>({
    mutationFn: ({ kpiId, input }) =>
      kpiApi.recordObservation(config, kpiId, input),
    onSuccess: (_data, { kpiId }) => invalidateAfterObservationWrite(qc, kpiId),
  });
}
